import React, { FC, useEffect } from "react";
import injectSheet from "react-jss";
import styleSheet from "./styles";

interface Props {
  action?: string;
  autoComplete? : "on" | "off";
  enctype?: "application/x-www-form-urlencoded" | "multipart/form-data" | "text/plain";
  method?: "get" | "post";
  name: string;
  noValidate?: boolean;
  target?: "_parent" | "_top" | "_blank" | "_self" | string;
  readyToSubmit?: (ref: React.RefObject<HTMLFormElement>) => void;
}

const Form: FC<Props> = props => {
  const ref = React.createRef<HTMLFormElement>();

  const {
    action,
    autoComplete,
    enctype,
    method,
    name, 
    noValidate,
    target,
    readyToSubmit,
    children
  } = props;

  useEffect(() => {
    readyToSubmit ? readyToSubmit(ref) : null;
  })
  return (
    <form
      action={action}
      autoComplete={autoComplete}
      encType={enctype}
      method={method}
      name={name}
      noValidate={noValidate}
      target={target}
      ref={ref}
    >
      {children}
    </form>
  );
};

export default injectSheet(styleSheet)(Form);
